import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CalendarCardProps extends Vue {
  // Props
  @Prop({ type: Date, required: true })
  value: Date;
}



// WEBPACK FOOTER //
// ./src/components/calendar/card/props.ts